export const FETCH_DELETE_REQUEST = 'FETCH_DELETE_REQUEST'
export const FETCH_DELETE_SUCCESS = 'FETCH_DELETE_SUCCESS'
export const FETCH_DELETE_FAILURE = 'FETCH_DELETE_FAILURE'